import { Controller } from "@hotwired/stimulus"

// ponytail: browser date, no reset awareness; the server preview after save is authoritative
export default class extends Controller {
  static targets = ["prefix", "pattern", "padding", "next", "preview"]

  insert(event) {
    const input = this.patternTarget
    const start = input.selectionStart ?? input.value.length
    const end = input.selectionEnd ?? start
    input.value = input.value.slice(0, start) + event.currentTarget.dataset.token + input.value.slice(end)
    input.focus()
    this.update()
  }

  update() {
    const d = new Date()
    const pad = (n, w = 2) => String(n).padStart(w, "0")
    const tokens = {
      PREFIX: this.prefixTarget.value, YYYY: d.getFullYear(), YY: String(d.getFullYear()).slice(2),
      MM: pad(d.getMonth() + 1), DD: pad(d.getDate()), WW: pad(this.#isoWeek(d)),
      SEQ: pad(this.nextTarget.value || 1, Number(this.paddingTarget.value) || 1)
    }
    this.previewTarget.textContent = this.patternTarget.value.replace(/\{(\w+)\}/g, (match, key) => tokens[key] ?? match)
    for (const chip of this.element.querySelectorAll("[data-token]")) {
      chip.toggleAttribute("data-in-use", this.patternTarget.value.includes(chip.dataset.token))
    }
  }

  #isoWeek(date) {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7))
    return Math.ceil(((d - new Date(Date.UTC(d.getUTCFullYear(), 0, 1))) / 86400000 + 1) / 7)
  }
}
